import React, { useState, useEffect } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import { BlogsScroller } from "./BlogsScroller";
import { getAllBlogs } from "services";
import { useRouter } from "next/router";
import { DateTime } from "luxon";
interface BlogsData {
  date?: string;
  title?: string;
  description?: string;
  imageLink?: string;
  link?: string;
  category?: string;
}

export default function BlogsComponent() {
  const [blogsData, setBlogsData] = useState<BlogsData[]>([]);
  const router = useRouter();
  const init = async () => {
    const allLatestPosts: any = await getAllBlogs();
    const filteredData =
      [...(allLatestPosts?.data || [])].map((blog: any) => {
        const blogHeroCoverImage = blog.attributes.image.data.attributes.url;
        return {
          date: DateTime.fromISO(blog.attributes.publishedAt)
            .setZone("Asia/Kolkata")
            .toFormat("dd MMM yyyy"),
          title: blog.attributes.title.split(" ").slice(0, 10).join(" "),
          description: blog.attributes.description
            .split(" ")
            .slice(0, 10)
            .join(" "),
          imageLink: blogHeroCoverImage,
          link: `/blogs/${blog.attributes.slug}`,
          category: blog.attributes.category.data.attributes.name,
        };
      }) || [];
    setBlogsData(filteredData);
  };

  useEffect(() => {
    (async () => {
      await init();
    })();
  }, []);

  return (
    <>
      <div className="hidden lg:flex ">
        <div className=" w-full pl-customPadding mt-20  2xl:w-[1340px] 2xl:mx-auto 2xl:px-0 ">
          <div className=" flex  py-[50px] overflow-x-auto">
            <div className="min-w-[361px]">
              <p className="font-spaceGrotesk font-normal text-web-h2 leading-[59px] text-brand-textBlack ">
                Blogs , insights & stories
              </p>
              <p className="mt-[22px] font-openSans font-normal text-web-body-lg leading-[21px] text-brand-textGrey">
                Stay up to date with the latest stories and commentary.
              </p>
              <Button
                onClick={() => router.push("/blogs")}
                className="px-4 h-[60px] w-[187px] mt-24"
              >
                <p className="font-openSans font-semibold text-[22px] leading-[30px] text-white">
                  View More
                </p>
              </Button>
            </div>

            <BlogsScroller
              className="ml-[74px] scrollbar-hide"
              blogsData={blogsData.splice(0, 6)}
            />
          </div>
        </div>
      </div>
    </>
  );
}
